<div class="payment-view-container">
  <!-- Header -->
  <div class="page-header">
    <button mat-icon-button (click)="goBack()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="page-title">Payment Details</h1>
    <div class="header-actions">
      <button mat-raised-button color="primary" (click)="printBill()" *ngIf="payment">
        <mat-icon>print</mat-icon>
        Print Receipt
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading payment details...</p>
  </div>

  <!-- Payment Details -->
  <div *ngIf="!loading && payment" class="payment-details">
    <!-- Transaction Information Card -->
    <mat-card class="details-card">
      <mat-card-header>
        <mat-card-title>Transaction Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="details-grid">
          <!-- Transaction ID -->
          <div class="detail-item">
            <span class="label">Transaction ID</span>
            <span class="value">{{ payment.transactionId || '—' }}</span>
          </div>

          <!-- Payment Reference ID -->
          <div class="detail-item">
            <span class="label">Payment Reference ID</span>
            <span class="value">{{ payment.paymentReferenceId || '—' }}</span>
          </div>

          <!-- Receipt Number -->
          <div class="detail-item">
            <span class="label">Receipt Number</span>
            <span class="value">{{ payment.trxReceiptNumber || '—' }}</span>
          </div>

          <!-- Transaction Date -->
          <div class="detail-item">
            <span class="label">Transaction Date</span>
            <span class="value">{{ formatDate(payment.transactionDate) }}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Payer Information Card -->
    <mat-card class="details-card">
      <mat-card-header>
        <mat-card-title>Payer Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="details-grid">
          <!-- Payer Name -->
          <div class="detail-item">
            <span class="label">Payer Name</span>
            <span class="value">{{ payment.payerName || '—' }}</span>
          </div>

          <!-- Payer Email -->
          <div class="detail-item">
            <span class="label">Email</span>
            <span class="value">{{ payment.payerEmail || '—' }}</span>
          </div>

          <!-- Payer Phone -->
          <div class="detail-item">
            <span class="label">Phone Number</span>
            <span class="value">{{ payment.payerPhoneNumber || '—' }}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Payment Information Card -->
    <mat-card class="details-card">
      <mat-card-header>
        <mat-card-title>Payment Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="details-grid">
          <!-- Bill Amount -->
          <div class="detail-item">
            <span class="label">Bill Amount</span>
            <span class="value highlight-amount">{{ formatAmount(payment.billAmount) }}</span>
          </div>

          <!-- Paid Amount -->
          <div class="detail-item">
            <span class="label">Paid Amount</span>
            <span class="value highlight-amount success">{{ formatAmount(payment.paidAmount) }}</span>
          </div>

          <div class="detail-item">
            <span class="label">Currency Type</span>
            <span class="value highlight-amount info">{{ payment.bill.currencyType || '—' }}</span>
          </div>

          <!-- SP Code -->
          <div class="detail-item">
            <span class="label">Service Provider Code</span>
            <span class="value">{{ payment.spCode || '—' }}</span>
          </div>

          <!-- SP Name -->
          <div class="detail-item">
            <span class="label">Service Provider Name</span>
            <span class="value">{{ payment.spName || '—' }}</span>
          </div>

          <!-- PSP Code -->
          <div class="detail-item">
            <span class="label">PSP Code</span>
            <span class="value">{{ payment.pspCode || '—' }}</span>
          </div>

          <!-- PSP Name -->
          <div class="detail-item">
            <span class="label">PSP Name</span>
            <span class="value">{{ payment.pspName || '—' }}</span>
          </div>

          <!-- Reconciliation Status -->
          <div class="detail-item">
            <span class="label">Reconciliation Status</span>
            <span class="value">
              <mat-chip [class.reconciled]="payment.reconciled" [class.not-reconciled]="!payment.reconciled">
                {{ payment.reconciled ? 'Reconciled' : 'Not Reconciled' }}
              </mat-chip>
            </span>
          </div>
          <!-- Payment Status -->
<div class="detail-item" *ngIf="payment.bill">
  <span class="label">Payment Status</span>
  <span class="value">
    <mat-chip [class.status-paid]="payment.bill.paymentStatus === 'PAID'">
      {{ payment.bill.paymentStatus || '—' }}
    </mat-chip>
  </span>
</div>

<!-- Payment Type -->
<div class="detail-item" *ngIf="payment.bill">
  <span class="label">Payment Type</span>
  <span class="value">
    {{ payment.bill.paymentType || '—' }}
  </span>
</div>

<!-- TXN Auth ID -->
<div class="detail-item" *ngIf="payment.bill">
  <span class="label">Txn Auth ID</span>
  <span class="value">
    {{ payment.bill.txnAuthId || '—' }}
  </span>
</div>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- Bill Information Card -->
    <mat-card class="details-card" *ngIf="payment.bill">
      <mat-card-header>
        <mat-card-title>Bill Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="details-grid">
          <!-- Bill ID -->
          <div class="detail-item">
            <span class="label">Bill ID</span>
            <span class="value">{{ payment.bill.billId || '—' }}</span>
          </div>

          <!-- Bill Date -->
          <div class="detail-item">
            <span class="label">Bill Date</span>
            <span class="value">{{ formatDate(payment.bill.billDate) }}</span>
          </div>

          <!-- Bill Status -->
          <div class="detail-item">
            <span class="label">Bill Status</span>
            <span class="value">
              <mat-chip [class.status-paid]="payment.bill.billStatus === 'PAID'">
                {{ payment.bill.billStatus || '—' }}
              </mat-chip>
            </span>
          </div>

          <!-- Total Amount -->
          <div class="detail-item">
            <span class="label">Total Amount</span>
            <span class="value highlight-amount">{{ formatAmount(payment.bill.totalAmount) }}</span>
          </div>
        </div>

        <!-- Bill Items -->
        <div class="bill-items" *ngIf="payment.bill.billItems && payment.bill.billItems.length">
          <h3 class="subsection-title">Bill Items</h3>
          <mat-table [dataSource]="payment.bill.billItems" class="bill-items-table">
            <!-- Product Name Column -->
            <ng-container matColumnDef="productName">
              <mat-header-cell *matHeaderCellDef>Product</mat-header-cell>
              <mat-cell *matCellDef="let item">{{ item.productName }}</mat-cell>
            </ng-container>

            <!-- Quantity Column -->
            <ng-container matColumnDef="quantity">
              <mat-header-cell *matHeaderCellDef>Quantity</mat-header-cell>
              <mat-cell *matCellDef="let item">{{ item.quantity }}</mat-cell>
            </ng-container>

            <!-- Amount Column -->
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
              <mat-cell *matCellDef="let item">{{ formatAmount(item.amount) }}</mat-cell>
            </ng-container>

            <!-- Total Column -->
            <ng-container matColumnDef="totalAmount">
              <mat-header-cell *matHeaderCellDef>Total</mat-header-cell>
              <mat-cell *matCellDef="let item">{{ formatAmount(item.totalAmount) }}</mat-cell>
            </ng-container>
              

            <mat-header-row *matHeaderRowDef="['productName', 'quantity', 'amount', 'totalAmount']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['productName', 'quantity', 'amount', 'totalAmount']"></mat-row>
          </mat-table>
        </div>
        
      </mat-card-content>
    </mat-card>

  
  </div>

  <!-- No Data State -->
  <div *ngIf="!loading && !payment" class="no-data">
    <mat-icon>error_outline</mat-icon>
    <p>Payment not found</p>
    <button mat-raised-button color="primary" (click)="goBack()">
      Return to List
    </button>
  </div>
</div>